import React from 'react';
import Classes from './Documents.module.css';
import RecordTable from './RecordTable/RecordTable';

export default function Documents({ bookingId }) {
  return (
    <div className={Classes.hero}>
      <RecordTable bookingId={bookingId} />
    </div>
  );
}
